module.exports = __webpack_public_path__ + "de152389c2ee4d9ccfda5f512a2211c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/naiyou.jpg
// module id = 230
// module chunks = 30